import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broker-settings',
  templateUrl: './broker-settings.component.html',
  styleUrls: ['./broker-settings.component.scss']
})
export class BrokerSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
